'use client';

import { useEffect, useState } from 'react';
import { getAppConfig } from '@bts-web/core-app-config';
import { DatadogErrorLevels } from '@bts-web/utils-next-infrastructure';
import { datadogErrorHelper } from '../../../common/utils/datadogErrorHelper';
import { setLegacyPendingOrderFlowKeyAction } from './legacyPendingTradeFlowCookie.actions';

/**
 * Legacy-only: runs setLegacyPendingOrderFlowKeyAction when useLegacyOperationUrls is true
 * and exposes isLegacyCookieReady so the UI can disable the verify button until the cookie is set.
 * Remove with legacy flow.
 * See trade/AccepBackwardsCompatibilityInterceptor/legacy-freeze/README.md
 */
export function useSetLegacyPendingOrderFlowKey(): {
  isLegacyCookieReady: boolean;
} {
  const isLegacy = getAppConfig().useLegacyOperationUrls;

  const [isLegacyCookieReady, setIsLegacyCookieReady] = useState(!isLegacy);

  useEffect(() => {
    if (!isLegacy) return;

    setLegacyPendingOrderFlowKeyAction()
      .then(() => setIsLegacyCookieReady(true))
      .catch((error) => {
        datadogErrorHelper({
          errorMessage: `[ERR][setLegacyPendingOrderFlowKey] ${error}`,
          errorSeverity: DatadogErrorLevels.CRITICAL,
        });

        setIsLegacyCookieReady(true);
      });
  }, [isLegacy]);

  return { isLegacyCookieReady };
}
